// Render an order's external ID with an optional "#N" part suffix when the
// order is part of a multi-part split. Drop-in replacement anywhere a list
// or table shows `order.order_id_external`. The Part suffix is only shown
// for the actual split parts (total_parts > 1), so non-split orders are
// rendered identically to before.

export default function OrderIdCell({ order }) {
  if (!order) return null;
  const showPart = order.total_parts && order.total_parts > 1;
  return (
    <span className="font-mono">
      {order.order_id_external}
      {showPart && (
        <span className="ml-1 text-xs text-blue-700 font-semibold">
          #{order.part_number}
        </span>
      )}
    </span>
  );
}
